import React from "react";
import UI5ControlButton from "../../../../../layout/app-controls/buttons/button/button";
import AIChatMessage_Collection from "../../../../../core/model2/ai/chat-message/collection";
import AIChatMessage from "../../../../../core/model2/ai/chat-message/chat-message";
import VScroll from "../../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll";
import MessageDebugItem from "./message-debug-item";
import MessageDebugTokensUsage from "./message-debug-tokens";
import ModalV5 from "../../../../ui/modal/v5/v5";

type Props = {
    messageCollection   : AIChatMessage_Collection
}

const debug = false
// const debug = "AIChatMessageDebug"

export default function AIChatMessageDebug(props: Props) {

    debug && console.log(debug,"models", props.messageCollection.models)

    const renderContent = ()=> {
        return <ModalV5 className=" min-h-500" style={{width: '60%', maxHeight: '100vh'}}>
            <div style={{userSelect: "text"}}>
                <div className="ui5-title-small flex-row-center-center m-t-15"> User-Backend-AI Chat </div>

                <VScroll containerClass="p-15"
                         containerStyle={{whiteSpace: "pre-wrap", height: 800, maxWidth: '100%'}}>

                    {_.map(props.messageCollection.models, (message: AIChatMessage, key: number) => {

                        if (message.isChatName) {
                            return (
                                <div style={{width: "100%"}}>
                                    <div className="">BACKEND → AI (GENERATE CHAT NAME)</div>
                                    <div className="ui5-card s-large gray">

                                        <MessageDebugItem title="Request" data={message.request} expandableSubItems={true}/>
                                        <MessageDebugItem title="Response" data={message.response} expandableSubItems={true}/>

                                        <MessageDebugTokensUsage message={message}/>


                                    </div>
                                </div>
                            )
                        }
                        if (message.isAiVectorGeneration) {
                            return (
                                <div style={{width: "100%"}}>
                                    <div className="">BACKEND → AI (GENERATE VECTOR)</div>
                                    <div className="ui5-card s-large gray m-b-30">

                                        <MessageDebugItem title="Request" data={message.request} expandableSubItems={true}/>
                                        <MessageDebugItem title="Response" data={message.response} expandableSubItems={true}/>

                                        <MessageDebugTokensUsage message={message}/>

                                    </div>
                                </div>
                            )
                        }

                        if (message.isToolSelection) {
                            return (
                                <div style={{width: "100%"}}>
                                    <div className="">BACKEND → BACKEND (TOOL SELECTION)</div>
                                    <div className="ui5-card s-large gray m-b-30">
                                        <MessageDebugItem title="Tools by embeddings" data={message.response?.toolsByEmbeddings}/>
                                        <MessageDebugItem title="Recent tools" data={message.response?.recentTools}/>

                                    </div>
                                </div>
                            )
                        }

                        if (message.isQuery){
                            return (
                                <div style={{width: "100%", alignSelf: "flex-end"}}>
                                    <div className="">USER → BACKEND (QUERY)</div>
                                    <div className="ui5-card s-large bg-system-pale-action m-b-30">

                                        <MessageDebugItem title="Input" data={message?.message} expanded={true}/>

                                    </div>
                                </div>
                            )
                        }

                        // if (message.isContext){
                        //     return (
                        //         <div style={{width: "100%", alignSelf: "flex-end"}}>
                        //             <div className="">BACKEND → AI (CONTEXT MESSAGE)</div>
                        //             <div className="ui5-card s-large bg-system-pale-action m-b-30">
                        //
                        //                 <MessageDebugItem title="Input" data={message?.message} expanded={true}/>
                        //
                        //             </div>
                        //         </div>
                        //     )
                        // }

                        if (message.isBackendAiTurnsExited){
                            return (
                                <div style={{width: "100%", alignSelf: "flex-end"}}>
                                    <div className="">BACKEND → AI (TURNS EXITED)</div>
                                    <div className="ui5-card s-large bg-system-pale-action m-b-30">

                                        <MessageDebugItem title="Input" data={message?.message} expanded={true}/>

                                    </div>
                                </div>
                            )
                        }

                        if (message.isToolsCallsRequest) {
                            return (
                                <div style={{width: "100%"}}>
                                    <div className="">BACKEND → AI (TOOL CALLS REQUEST)</div>
                                    <div className="ui5-card s-large gray m-b-30">

                                        <MessageDebugItem title="Tool calls" data={message.messageJson} expanded={true}/>
                                        <MessageDebugItem title="Request" data={message.request} expandableSubItems={true}/>
                                        <MessageDebugItem title="Response" data={message.response} expandableSubItems={true}/>

                                        <MessageDebugTokensUsage message={message}/>

                                    </div>
                                </div>
                            )
                        }


                        if (message.isToolsCallsResponse) {
                            return (
                                <div style={{width: "100%", alignSelf: "flex-end"}}>
                                    <div className="">BACKEND → DB (TOOL CALLS RESPONSE)</div>
                                    <div className="ui5-card s-large bg-system-pale-action m-b-30">
                                        <MessageDebugItem title="Tool Calls Output" data={message.messageJson} expanded={true}/>

                                        <MessageDebugItem title="Request" data={message.request} expandableSubItems={true}/>
                                        <MessageDebugItem title="Response" data={message.response} expandableSubItems={true}/>
                                    </div>
                                </div>
                            )
                        }


                        if (message.isAnswer) {
                            return (
                                <div style={{width: "100%"}}>
                                    <div className="">BACKEND → AI (ANSWER)</div>
                                    <div className="ui5-card s-large gray m-b-30">


                                        <MessageDebugItem title="Answer" data={message.message} expanded={true}/>
                                        <MessageDebugItem title="Request" data={message.request} expandableSubItems={true}/>
                                        <MessageDebugItem title="Response" data={message.response} expandableSubItems={true}/>

                                        <MessageDebugTokensUsage message={message}/>
                                    </div>
                                </div>
                            )
                        }


                        if (message.isCompaction) {
                            return (
                                <div style={{width: "100%"}}>
                                    <div className="">AI → BACKEND (COMPACTION)</div>
                                    <div className="ui5-card s-large gray m-b-30">

                                        <MessageDebugItem title="Instructions" data={message?.metadata?.instructions}/>
                                        <MessageDebugItem title="Input" data={message.metadata?.input}/>
                                        <MessageDebugItem title="Output" data={message.metadata?.output}/>
                                        <MessageDebugItem title="Full response" data={message.metadata?.response}/>

                                        <MessageDebugTokensUsage message={message}/>

                                    </div>
                                </div>
                            )
                        }


                        if (message.isError) {
                            return (
                                <div key={key} className="flex-column-left-top w-100p">
                                    <div style={{width: "100%", alignSelf: "flex-end"}}>
                                        <div className="">AI → BACKEND (ERROR)</div>
                                        <div className="ui5-card s-large bg-system-paleBg-red m-b-30">

                                            <MessageDebugItem title="Request" data={message.request} expandableSubItems={true}/>
                                            <MessageDebugItem title="Response" data={message.response} expandableSubItems={true}/>

                                        </div>
                                    </div>

                                </div>
                            )
                        }


                    })}
                </VScroll>
            </div>
        </ModalV5>
    }
    const showModel = ()=> {
        gd.modal.showV5(renderContent())
    }

    return (
        <UI5ControlButton className="p-l-5 p-r-5 m-l-10" onClick={showModel}>
            <div>Debug</div>
        </UI5ControlButton>
    )
}
